<template lang="html">
  <div class="row">
    <team-new></team-new>
    <div class="col-sm-5">
      <teams-list></teams-list>
    </div>
    <div class="col-sm-3">
      <team-selected></team-selected>
    </div>
    <div class="col-sm-4">
      <team-players></team-players>
    </div>
  </div>
</template>

<script>
import Team from '../../api/team'
import TeamsList from './TeamsList'
import TeamSelected from './TeamSelected'
import TeamPlayers from './TeamPlayers'
import TeamNew from './TeamNew'
import {getConfigChampionship} from '../../vuex/getters'
import * as actions from '../../vuex/actions'
export default {
  vuex: {
    getters: {
      championship: getConfigChampionship
    },
    actions
  },
  data() {
    return {
    }
  },
  computed: {},
  ready() {},
  attached() {},
  methods: {},
  components: { TeamsList, TeamSelected, TeamPlayers, TeamNew }
};
</script>

<style lang="css">
</style>



/** WEBPACK FOOTER **
 ** Team.vue?aed0476e
 **/